import React from "react";
import { useNavigate } from "react-router-dom";
import ModalLayout from "../layouts/ModalLayout";
import { popupNavigation } from "../../util/functions/UniversalFunctions";
import CustomButton from "../CustomButton";
import { AppDispatch } from "../../store";
import { useDispatch } from "react-redux";
import { removeLocalStorage } from "../../util/manageStorage";
import { logout } from "../../features/user/UserSlice";

interface Props {
  isOpen: boolean;
}

export default function SubscriptionExpiredModal({ isOpen }: Props) {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  if (!isOpen) return null;

  const handleLogout = () => {
    dispatch(logout("Logged out successfully"));
    removeLocalStorage("selectedBranchCode");

    navigate("/login");
  };

  return (
    <ModalLayout onClose={() => {}} isCross={false} width="max-w-md">
      <div className="flex flex-col items-center text-center space-y-6">
        <h2 className="text-xl font-semibold text-error-400">
          Subscription Expired
        </h2>

        <p className="text-sm text-neutral-400 leading-relaxed px-2">
          Your subscription has expired. Please contact{" "}
          <a
            href="mailto:hr@empedance.com"
            className="text-primary-500 font-semibold"
          >
            hr@empedance.com
          </a>{" "}
          or renew your plan to regain access to the platform.
        </p>

        <div className="w-full flex flex-col justify-center items-center gap-3 pt-2">
          {/* <button
            disabled
            className="bg-primary-500 text-white py-2 rounded-md"
          >
            Contact Admin
          </button> */}

          <CustomButton
            onClick={handleLogout}
            text="Logout"
            color="bg-error-500 "
          />
        </div>
      </div>
    </ModalLayout>
  );
}
